import React, { useMemo, Fragment, useState, useEffect } from 'react';
import MpgInput from "../../../../CommonFormComp/MpgInput";
import { useForm, SubmitHandler } from "react-hook-form"
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Link, useParams, useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import AddBioDialog from '../AddBioDialog';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import MpgFileUpload from '../../../../fileHandling/MpgFileUpload';
import { useUpdateTeamMemberByIdMutation, useDeleteTeamMemberByIdMutation, useUploadProfilePicOfTeamMemberMutation } from '../../../../reactQueries/AppApi/rqHooksForAccountTeamMembers';
import Stack from "@mui/material/Stack";
import BioTable from "../BioTable";
import EditBioDialog from "../EditBioDialog";
import { accountTeamMemberViewPath } from "../../../../routes/routePaths";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../common/dialog/MpgLoadingDialog";
import { useFileDownloadMutation } from "../../../../reactQueries/commonRQHooks";
import { useGetLoggedInUserDetails } from "../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { saveAs } from "file-saver";
import MuiLink from '@mui/material/Link';
import useTrackUserActivity from "../../../../userActivityTracking/useTrackUserActivity";
import { getGUIDAndExtentionFromFileURL } from "../../../../hooksAndFunctions/functions/getGUIDAndExtentionFromFileURL";
import { getAccessTypes } from "../../../../hooksAndFunctions/functions/getAccessTypes";
import { useGetSiteCoreCMSData } from '../../../../reactQueries/commonRQHooks';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const EditAccountTeamMembers = ({ teamMemberDataById }) => {
    const navigate = useNavigate();

    const {
        clientPortalAdminType
    } = getAccessTypes()
    const {
        isClientPortalAdmin,
        hasA4Access
    } = clientPortalAdminType

    const { Id: staffId } = useParams();

    const userName = JSON.parse(window.sessionStorage.getItem('UserAccount'))?.["name"];

    const { loggedInUser } = useGetLoggedInUserDetails();
    const { id: userId } = loggedInUser;

    const { mutate: DownloadProfileImg, isError: isErrorOnDownload, isLoading: isLoadingOnDownload, isSuccess: isSuccessOnDownload, data: dataOnDownload, error: errorOnDownload } = useFileDownloadMutation()

    /**API calls to CreateTeamMember */
    const { mutate: updateTeamMember, isError: isErrorOnUpdate, isLoading: isLoadingOnUpdate, isSuccess: isSuccessOnUpdate, data: dataOnUpdate, error: errorOnUpdate } = useUpdateTeamMemberByIdMutation()

    const { mutate: deleteTeamMemberById, isError: isErrorOnDelete, isLoading: isLoadingOnDelete, isSuccess: isSuccessOnDelete, data: dataOnDelete, error: errorOnDelete } = useDeleteTeamMemberByIdMutation()

    const { mutate: uploadProfilePic, isError: isErrorOnProfilePicUpload, isLoading: isLoadingOnProfilePicUpload, isSuccess: isSuccessOnProfilePicUpload, data: dataOnProfilePicUpload, error: errorOnProfilePicUpload } = useUploadProfilePicOfTeamMemberMutation()

    const { isSuccess: isSuccessOnSiteCoreCMS, error: errorOnSiteCoreCMS, data: adminAccountCMSDataFromAPI, isError: isErrorOnSiteCoreCMS, isFetching: isFetchingOnSiteCoreCMS } = useGetSiteCoreCMSData({ pagename: "AccountTeam" });

    const [adminAccountTeamCMSData, setAdminAccountTeamCMSData] = useState({ title: "", description: "", tabNavigationTitle: "", pageContent: {} });

    //#region  CMS Content hadling

    const fetchAdminAccountTeamCMSData = () => {
        if (adminAccountCMSDataFromAPI && adminAccountCMSDataFromAPI?.Pages) {
            adminAccountCMSDataFromAPI.Pages.map((el) => {
                if (el.Key === "AccountTeam") {
                    const { Title, Description, TabNavigationTitle, Components } = el;
                    setAdminAccountTeamCMSData({ title: Title, description: Description, tabNavigationTitle: TabNavigationTitle, pageContent: Components });
                }
            });
        }
    }

    useEffect(() => {
        fetchAdminAccountTeamCMSData();
    }, [adminAccountCMSDataFromAPI])

    const fetchAdminAccountTeamDetailsLabel = (key) => {
        if (adminAccountTeamCMSData && adminAccountTeamCMSData?.pageContent["AccountTeamMemberDetailsComponent"]) {
            const adminAccountCMSDataLabel = adminAccountTeamCMSData.pageContent["AccountTeamMemberDetailsComponent"];
            return returnLabel(adminAccountCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray=[], key) => {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    // #endregion

    /**bio handling */

    const [bioDetailTableData, setBioDetailTableData] = useState([])
    /**take only active bios */
    useEffect(() => {
        if (!!teamMemberDataById?.BioDetail && teamMemberDataById?.BioDetail.length) {
            const activeBioList = teamMemberDataById?.BioDetail.filter((item) => {
                if (!!item?.IsActive) {
                    return item
                }
            })
            setBioDetailTableData(activeBioList)
        } else {
            setBioDetailTableData([])
        }
    }, [teamMemberDataById])

    const [removedBioList, setRemovedBioList] = useState([])

    // console.log("abc:", bioDetailTableData)

    /**form handling */
    const schema = yup.object().shape({
        first_name: yup.string().label('This field').required().max(100),
        last_name: yup.string().label('This field').required().max(100),
        email: yup.string().label('This field').email().required().max(200),
        job_title: yup.string().label('This field').required().max(200),
        contact_no: yup.string().optional()
            .test("mobileNoValidation", fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ValidationMsgForMobileNumber'), (string) => {
                //const regex = /^[+][1-9][0-9]{7,14}$/
                const regex = /^\+[0-9](?:[\s\-]?[0-9]){7,18}$/
                return !string || (!!string && string.search(regex) !== -1)
            }),
        profileImg: yup.mixed().optional()
            .test("fileTypeValidation", fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ValidationMsgforUploadFileType'), (file) => {
                // console.log("gl-validate:", file)
                const fileTypeList = ["image/jpeg", "image/jpg", "image/png"]
                //if u want to allow only certain file types only

                return !file[0] || (!!file[0] && fileTypeList.includes(file[0].type))
            })
            .test("fileSizeValidation", fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ValidationMsgforUploadFileSize'), (file) => {
                // console.log("gl-validate:", file)
                //if u want to allow only certain file sizes
                return !file[0] || (!!file[0] && file[0].size <= 1 * 1024 * 1024)
            })

    });

    const defaultValues = {
        first_name: teamMemberDataById?.FirstName,
        last_name: teamMemberDataById?.LastName,
        email: teamMemberDataById?.EmailAddress,
        job_title: teamMemberDataById?.JobPosition,
        contact_no: teamMemberDataById?.ContactNo,
        profileImg: []
    }
    const rhfFormInstance = useForm({
        defaultValues,
        resolver: yupResolver(schema)
    });

    const [bodyDataForUpdate, setBodyDataForUpdate] = useState({})

    const onSubmit = (data) => {
        let listOfExistingBios_withoutNotFromDB = []
        let listOfNewlyAddedBios = []
        /**grab only newly added bio details which are marked by flag === "notFromDB" */

        if (!!bioDetailTableData.length) {
            bioDetailTableData.forEach((item) => {
                /**removing Id and flag properties */
                if (item?.flag === "notFromDB") {
                    const newEntry = {
                        Content: item?.Content,
                        IsActive: item?.IsActive,
                        LanguageDescription: item?.LanguageDescription,
                        LanguageId: item?.LanguageId,
                        TemplateTitle: item?.TemplateTitle,
                        CreatedBy: userName
                    }
                    /**after removving properties pushing */
                    listOfNewlyAddedBios.push(newEntry)
                } else {
                    listOfExistingBios_withoutNotFromDB.push(item)
                }
            })
        }
        const finalBio = [...listOfExistingBios_withoutNotFromDB, ...listOfNewlyAddedBios, ...removedBioList];

        const body = {
            Id: staffId,
            BrandId: teamMemberDataById.BrandId || '',
            FirstName: data.first_name || '',
            LastName: data.last_name || '',
            EmailAddress: data.email || '',
            ContactNo: data.contact_no || '',
            JobPosition: data.job_title || '',
            ProfilePhotoURL: teamMemberDataById?.ProfilePhotoURL,
            IsActive: true,
            UpdatedBy: userName || '',
            BioDetail: finalBio || []
        }
        setBodyDataForUpdate(body)

        if (!!data.profileImg[0]) {
            const file = data.profileImg[0]
            uploadProfilePic({ file })
        } else {
            updateTeamMember({ body, staffId })
        }
    }

    useEffect(() => {
        if (!!isSuccessOnProfilePicUpload) {

            const storedFileURL = dataOnProfilePicUpload.data.FileUrl
            const bodyData = {
                ...bodyDataForUpdate,
                ProfilePhotoURL: storedFileURL
            }
            updateTeamMember({ body: bodyData, staffId })
        }
    }, [isSuccessOnProfilePicUpload])

    useEffect(() => {
        if (!!isSuccessOnUpdate || !!isSuccessOnDelete) {
            navigate(accountTeamMemberViewPath)
        }
    }, [isSuccessOnUpdate, isSuccessOnDelete])

    /**dialog handling for bios*/
    const [open, setOpen] = React.useState(false);

    /**dialog handling for bios Edit*/
    const [openEditBioDialog, setOpenEditBioDialog] = React.useState(false);
    const [bioDetailObjToBeEdited, setBioDetailObjToBeEdited] = React.useState({});

    /**handling and processing for file download */
    const [fileDetails, setFileDetails] = useState({})
    /**{
     *  fileGUID:"dsdsdsdsdsdd",
     * fileExtension:"png",
     * } */
    useEffect(() => {
        if (!!teamMemberDataById?.ProfilePhotoURL) {
            const file = teamMemberDataById?.ProfilePhotoURL

            const splitFileURL = file.split("/")

            const fileGUIDWithExtension = splitFileURL.at(-1)

            const fileGUIDWithExtensionSplit = fileGUIDWithExtension.split('.')

            const fileGUID = fileGUIDWithExtensionSplit[0]
            const fileExtension = fileGUIDWithExtensionSplit[1]

            setFileDetails({
                fileGUID,
                fileExtension
            })
        } else {
            setFileDetails({})
        }
    }, [teamMemberDataById?.ProfilePhotoURL])

    useEffect(() => {
        if (!!isSuccessOnDownload) {
            saveAs(dataOnDownload, `${teamMemberDataById?.FirstName}-${teamMemberDataById?.LastName}_profileImg`);
        }
    }, [isSuccessOnDownload])

    /**tracking user Activity */
    const { trackActivity } = useTrackUserActivity()
    useEffect(() => {
        if (!!isSuccessOnDownload) {
            trackActivity({
                activitySuccess: !!isSuccessOnDownload,
                actionType: "Downloaded",
                itemId: fileDetails?.fileGUID || "",
            })
        }
        if (!!isSuccessOnProfilePicUpload) {
            const { fileGUID } = getGUIDAndExtentionFromFileURL({ fileURL: dataOnProfilePicUpload?.data?.FileUrl })

            trackActivity({
                activitySuccess: !!isSuccessOnProfilePicUpload,
                actionType: "Uploaded",
                itemId: fileGUID || "",
            })
        }
    }, [isSuccessOnDownload, isSuccessOnProfilePicUpload])


    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Typography variant="h5" align='center' sx={{ fontWeight: 'bolder' }}>
                    {fetchAdminAccountTeamDetailsLabel("AccountTeamMemberDetails.EditAccountTeamMemberHeading")}
                </Typography>

                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                    m={1}
                >
                    <Button
                        variant="outlined"
                        size="small"
                        component={Link}
                        to={accountTeamMemberViewPath}
                    >{fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.AccountTeamMembers')}</Button>

                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => {
                            const isActive = teamMemberDataById?.IsActive

                            if (!!isActive) {
                                deleteTeamMemberById({ isDeleteMode: true, staffId })
                            } else {
                                deleteTeamMemberById({ isDeleteMode: false, staffId })
                            }
                        }}
                    >{!!teamMemberDataById?.IsActive ? fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.DeactivateTeamMember') : fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ReactivateTeamMember')}</Button>
                </Stack>

                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
                >
                    <Item>
                        <Typography variant="h6" align='left' sx={{ fontWeight: 'bolder' }}>
                            {fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.MemberDetailsHeading')}
                        </Typography>
                        <Grid container spacing={1}>

                            <Grid item xs={12} sm={6}>
                                <MpgInput
                                    rhfFormInstance={rhfFormInstance}
                                    name={'first_name'}
                                    label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.FirstName')}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <MpgInput
                                    rhfFormInstance={rhfFormInstance}
                                    name={'last_name'}
                                    label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.LastName')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MpgInput
                                    rhfFormInstance={rhfFormInstance}
                                    name={'email'}
                                    label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.Email')}
                                    fullWidth
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MpgInput
                                    rhfFormInstance={rhfFormInstance}
                                    name={'job_title'}
                                    label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.JobTitle')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MpgInput
                                    rhfFormInstance={rhfFormInstance}
                                    name={'contact_no'}
                                    label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ContactNo')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <MpgFileUpload
                                    name="profileImg"
                                    label={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.ProfilePic')}
                                    rhfFormInstance={rhfFormInstance}
                                    persistantMsg={fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.MaxSizeAllowedMessage')}
                                />
                                { /** file download func */}
                                {
                                    !!teamMemberDataById?.ProfilePhotoURL && (
                                        <MuiLink
                                            onClick={() => {
                                                if (!!fileDetails?.fileGUID) {
                                                    DownloadProfileImg({
                                                        fileGUID: fileDetails?.fileGUID,

                                                        /**DownloadType: "profileImage"|"logo"|"reportAndResources" */
                                                        DownloadType: "profileImage",
                                                        Extension: fileDetails?.fileExtension,
                                                    });
                                                }
                                            }}
                                        >
                                            {`${teamMemberDataById?.FirstName}-${teamMemberDataById?.LastName}_profileImg`}
                                        </MuiLink>
                                    )
                                }

                            </Grid>
                        </Grid>
                    </Item>
                    <br />

                    <Item>
                        <Stack
                            direction={{ xs: "column", sm: "row" }}
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant="h6" align='center' sx={{ fontWeight: 'bolder' }}>
                            {adminAccountTeamCMSData?.pageContent["BioDetailListComponent"]?.Title}
                            </Typography>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setOpen(true)}
                            >{adminAccountTeamCMSData?.pageContent["BioDetailsComponent"]?.Title}
                            </Button>
                        </Stack>
                        <BioTable
                            tableData={bioDetailTableData}
                            setTableData={setBioDetailTableData}
                            setBioDetailObjToBeEdited={setBioDetailObjToBeEdited}
                            setOpenEditBioDialog={setOpenEditBioDialog}
                            removedBioList={removedBioList || []}
                            setRemovedBioListDuringEditFunc={setRemovedBioList}
                            cmsData={adminAccountTeamCMSData && adminAccountTeamCMSData}
                        />
                    </Item>


                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        justifyContent={"space-evenly"}
                        mt={3}
                    >
                        <Button
                            variant='contained'
                            size="small"
                            type='submit'
                            //disabled={!!hasA4Access}
                        >
                            {fetchAdminAccountTeamDetailsLabel('AccountTeamMemberDetails.UpdateMember')}
                        </Button>
                    </Stack>
                </Box >

                {/**Bio Dialog */}
                <AddBioDialog
                    open={open}
                    setOpen={setOpen}
                    bioDetailTableData={bioDetailTableData}
                    setBioDetailTableData={setBioDetailTableData}
                    cmsData={adminAccountTeamCMSData && adminAccountTeamCMSData}
                />

                {
                    !!bioDetailObjToBeEdited && bioDetailObjToBeEdited?.Id && (
                        <EditBioDialog
                            open={openEditBioDialog}
                            setOpen={setOpenEditBioDialog}
                            bioDetailTableData={bioDetailTableData}
                            setBioDetailTableData={setBioDetailTableData}
                            bioDetailObjToBeEdited={bioDetailObjToBeEdited}
                            cmsData={adminAccountTeamCMSData && adminAccountTeamCMSData}
                        />
                    )
                }

                {/** error dialog on update action */}
                <MpgErrorDialog
                    open={!!isErrorOnUpdate || !!isErrorOnProfilePicUpload || !!isErrorOnDelete || !!isErrorOnDownload}
                />
                <MpgLoadingDialog
                    open={
                        !!isLoadingOnUpdate ||
                        !!isLoadingOnDelete ||
                        !!isLoadingOnProfilePicUpload
                    }
                />
            </Box >
        </>
    )
}

export default EditAccountTeamMembers;